// original: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/1729733ab4b5cfdd5950af37c67157f5deb9589b/static/js/team/constants/keyPaths.js
export const CHILD_TEAMS = ['childTeams'];
export const ID = ['id'];
export const NAME = ['name'];
export const NUM_ROUTABLE_USERS_IN_HIERARCHY = ['numRoutableUsersInHierarchy'];
export const USERS = ['users'];
export const ROUTABLE_USER = ['routableUser'];